/** Disposições que mostram a barra lateral. */
export const THEME_SIDEBAR_LAYOUTS = [
    'sidebar-left',
    'sidebar-right',
    'categories-top-sidebar-left',
    'categories-top-sidebar-right',
];
/** Disposições com a barra de categorias no topo. */
export const THEME_CATEGORIES_TOP_LAYOUTS = [
    'categories-top',
    'categories-top-sidebar-left',
    'categories-top-sidebar-right',
];
/** Moldura das páginas: largura do conteúdo, barra lateral e onde ficam as categorias. */
export const THEME_FRAME_FIELDS = {
    layout: {
        type: 'select',
        label: 'Disposição',
        help: 'Onde ficam as categorias e a barra lateral.',
        options: [
            { value: 'categories-top', label: 'Categorias no topo' },
            { value: 'sidebar-left', label: 'Barra lateral à esquerda' },
            { value: 'sidebar-right', label: 'Barra lateral à direita' },
            { value: 'full-width', label: 'Largura total' },
            { value: 'categories-top-sidebar-left', label: 'Categorias no topo e barra à esquerda' },
            { value: 'categories-top-sidebar-right', label: 'Categorias no topo e barra à direita' },
        ],
        default: 'categories-top',
    },
    contentWidth: {
        type: 'select',
        label: 'Largura do conteúdo',
        help: 'Em telas grandes. No celular o conteúdo ocupa a tela toda.',
        options: [
            { value: 'narrow', label: 'Estreita' },
            { value: 'normal', label: 'Normal' },
            { value: 'wide', label: 'Larga' },
            { value: 'full', label: 'Tela inteira' },
        ],
        default: 'normal',
    },
};
//# sourceMappingURL=frame.js.map